import { QueovalBase, InfoBo } from '../global';

export class ActionCoBoModel extends QueovalBase {
  public BusinessObject: InfoBo;
}

